import { jsx as _jsx } from "react/jsx-runtime";
import { addDays, subDays, startOfWeek } from 'date-fns';
import AgendaContext from './context';
export default function Agenda({ startDate = startOfWeek(new Date()), onStartDateChange = () => { }, events = [], days = 7, children, }) {
    const context = {
        startDate,
        onStartDateChange,
        events,
        days,
    };
    const endDate = addDays(new Date(startDate), days - 1);
    const childrenProps = {
        prev: () => onStartDateChange(subDays(new Date(startDate), days)),
        next: () => onStartDateChange(addDays(new Date(startDate), days)),
        endDate,
    };
    return (_jsx(AgendaContext.Provider, { value: context, children: children(childrenProps) }));
}
